import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from '../../store';
import ConnectGithubAccountForm from '../../views/containers/ConnectGithubAccountForm';
import SwitchGitHubPromoPlanPopupManager from '../SwitchGitHubPromoPlanPopupManager';
import ToasterService from '../ToasterService';

export async function canSwitchToGitHubPromoPlan(githubStars, getGithubPromoInfo) {
    try {
        const { numOfStars } = await getGithubPromoInfo();
        if (numOfStars === undefined) {
            throw new Error("Can't retrieve info about GitHub stars");
        }
        if (githubStars > numOfStars) {
            ToasterService.showInfo({
                title: `You don't have enough stars to switch to this plan. Give stars to <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://github.com/alan-ai">Alan Repos</a> to switch to this plan
                `,
                onlyUserCanHide: true
            });
            return false;
        }
    } catch (err) {
        ToasterService.showError({
            title: `
            We were unable to retrieve info about the number of Alan repositories you have starred, to change the plan please <span id="githubBtnPlaceholder"></span>
            `,
            onlyUserCanHide: true
        });
        ReactDOM.render(
            <Provider store={store}>
                <ConnectGithubAccountForm
                    title="re-connect your GitHub account"
                    mode="link"
                    onBeforeClick={() => {
                        SwitchGitHubPromoPlanPopupManager.markOpenForFuture(store.getState().user.email);
                    }} />
            </Provider>, document.getElementById('githubBtnPlaceholder'));
        return false;
    }
    return true;
}